/**
 * Generate an annotated image with suggestion labels overlaid
 * @param {string} imageDataUrl - Base64 image data URL
 * @param {Array} annotationPoints - Array of {x, y, label} objects
 * @returns {Promise<string>} - Annotated image as data URL
 */
export const generateAnnotatedImage = async (imageDataUrl, annotationPoints) => {
  return new Promise((resolve, reject) => {
    try {
      // Create image element
      const img = new Image();
      img.crossOrigin = 'anonymous';
      
      img.onload = () => {
        // Create canvas
        const canvas = document.createElement('canvas');
        canvas.width = img.width;
        canvas.height = img.height;
        const ctx = canvas.getContext('2d');
        
        // Draw original image
        ctx.drawImage(img, 0, 0);
        
        // Draw simple numbered markers only
        annotationPoints.forEach((point, index) => {
          // Calculate pixel positions from percentages
          const x = (parseFloat(point.x) / 100) * canvas.width;
          const y = (parseFloat(point.y) / 100) * canvas.height;
          
          // Draw outer glow for visibility
          ctx.shadowColor = 'rgba(139, 92, 246, 0.8)';
          ctx.shadowBlur = 20;
          ctx.shadowOffsetX = 0;
          ctx.shadowOffsetY = 0;
          
          // Draw marker circle (larger for visibility)
          ctx.fillStyle = '#8B5CF6'; // Purple color
          ctx.beginPath();
          ctx.arc(x, y, 25, 0, 2 * Math.PI);
          ctx.fill();
          
          // Draw white border
          ctx.strokeStyle = '#FFFFFF';
          ctx.lineWidth = 3;
          ctx.stroke();
          
          // Reset shadow
          ctx.shadowColor = 'transparent';
          ctx.shadowBlur = 0;
          
          // Draw number in circle
          ctx.fillStyle = '#FFFFFF';
          ctx.font = 'bold 24px Arial';
          ctx.textAlign = 'center';
          ctx.textBaseline = 'middle';
          ctx.fillText(index + 1, x, y);
          
          // That's it - just numbered markers, no labels on image
        });
        
        // Convert to data URL
        const annotatedDataUrl = canvas.toDataURL('image/png', 0.95);
        resolve(annotatedDataUrl);
      };
      
      img.onerror = () => {
        reject(new Error('Failed to load image'));
      };
      
      img.src = imageDataUrl;
    } catch (error) {
      reject(error);
    }
  });
};
